'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: -39px;\n  display: none;\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    left: calc(50% - 32px);\n\n    svg {\n      width: 64px;\n    }\n  }\n\n  @media(min-width: ', ') {\n    display: block;\n  }\n'], ['\n  position: absolute;\n  top: -39px;\n  display: none;\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    left: calc(50% - 32px);\n\n    svg {\n      width: 64px;\n    }\n  }\n\n  @media(min-width: ', ') {\n    display: block;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../../config.js');

var _BriefcaseBadgeSVG = require('../../../svg/BriefcaseBadgeSVG');

var _BriefcaseBadgeSVG2 = _interopRequireDefault(_BriefcaseBadgeSVG);

var _GradCapBadgeSVG = require('../../../svg/GradCapBadgeSVG');

var _GradCapBadgeSVG2 = _interopRequireDefault(_GradCapBadgeSVG);

var _ScalesBadgeSVG = require('../../../svg/ScalesBadgeSVG');

var _ScalesBadgeSVG2 = _interopRequireDefault(_ScalesBadgeSVG);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, _config.breakpoints.m);

var Badge = function Badge(_ref) {
  var icon = _ref.icon;

  /* eslint-disable */
  // throws an error for react/display-name
  // we want to use the display name for the actual component that is being returned
  var IconMapper = function IconMapper() {
    if (icon === 'Briefcase') {
      return _BriefcaseBadgeSVG2.default;
    } else if (icon === 'GraduationCap') {
      return _GradCapBadgeSVG2.default;
    } else if (icon === 'JusticeScales') {
      return _ScalesBadgeSVG2.default;
    }

    return _react2.default.createElement('div', null);
  };
  /* eslint-enable */

  var IconToRender = IconMapper();

  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(IconToRender, {
      badgeColor: _config.colors.white,
      iconColor: _config.colors.darkBlue,
      height: '65px'
    })
  );
};

Badge.propTypes = {
  icon: _propTypes2.default.oneOf(['Briefcase', 'GraduationCap', 'JusticeScales', 'None']).isRequired
};

Badge.displayName = 'Badge';

exports.default = Badge;
Badge.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Badge',
  'props': {
    'icon': {
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'Briefcase\'',
          'computed': false
        }, {
          'value': '\'GraduationCap\'',
          'computed': false
        }, {
          'value': '\'JusticeScales\'',
          'computed': false
        }, {
          'value': '\'None\'',
          'computed': false
        }]
      },
      'required': true,
      'description': ''
    }
  }
};